import React from 'react';

import ChatRoomPanel from './chatroom_panel'
import MessagesView from './messages_view'
import experimentState, {ApplicationState} from "./state/experimentState";
import mouseState from "./state/mouseState";

import {observer} from "mobx-react"
import themeState from "./state/themeState";
import backend from "./backend";
import AdminPanel from "./admin_panel";

const ChatRoom = observer(
    class extends React.Component {
        constructor(props) {
            super(props)

            let state = {
                questions: this.props.questions,
            }
            this.state = state
        }

        onSendAdminMessage(evt) {
            if (experimentState.runId >= this.state.questions.length) {
                backend.actionSendFinish({})
            } else {
                experimentState.startSendingQuestions(1)
                backend.actionSendQuestion()
            }
        }

        render() {
            let users_typing = "";
            let list_user_typing = (Object.keys(experimentState.users_typing).filter((key) => (experimentState.users_typing[key] && (key !== experimentState.user))))
            if (list_user_typing.length === 1) {
                users_typing = `${list_user_typing.join(',')} is aan het typen...`;
            } else if (list_user_typing.length > 1) {
                users_typing = `${list_user_typing.join(',')} zijn aan het typen...`;
            } else {
                // Empty so that the space keeps occupied
                users_typing = "   "
            }
            return <div className="room"
            >
                <h2 style={{
                    color: themeState.colour_text,
                    backgroundColor: themeState.colour_primary,
                    borderRadius: "10px",
                    paddingTop: "1.5em",
                    paddingBottom: "1.5em"
                }}>Welkom {experimentState.useProfile.firstname}</h2>
                <MessagesView chatQuestions={this.state.questions}/>
                <span style={{marginTop: '20px'}} className="typing">{users_typing}</span>
                <ChatRoomPanel onAdminSendMessage={this.onSendAdminMessage.bind(this)} finalQuestion={experimentState.runId >= this.state.questions.length}/>
                {experimentState.experimentParams.admin? <AdminPanel/> : null}
            </div>
        }
    }
)

export default ChatRoom;